<template>
	<div class="news-wrap" :fenqu="fenqu">
		<el-form label-width="100px" :model="form"  ref="form" :rules="rules">
			<el-form-item label="公司名称" prop="company">
				<el-input v-model="form.company" placeholder="请输入公司名称" />
			</el-form-item>
			<el-form-item label="展品" prop="department">
				<el-input v-model="form.department" placeholder="请输入展品" />
			</el-form-item>
			<el-form-item label="面积" prop="post">
				<el-input v-model="form.post" placeholder="请输入面积" />
			</el-form-item>
			<el-form-item label="所属行业" prop="industry">
				<el-select v-model="form.industry" placeholder="请选择所属行业">
				    <el-option
				      v-for="item in options"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				  </el-select>
			</el-form-item>
			
			<el-form-item label="联系人">
				<el-input placeholder="请输入姓名" v-model="form.name" />
			</el-form-item>
			<el-form-item label="联系电话">
				<el-input placeholder="请输入联系电话" v-model="form.phone" />
			</el-form-item>
			<el-form-item label="展位号">
				<el-select v-model="form.fenqu_id"  placeholder="请选择展区"  @change="handleChange">
					<el-option v-for="(item,index) in fenqu" :value="item.value" :key='index'
						:label="item.value">
					</el-option>
				</el-select>
				<el-input style="width: 216px;margin-left: 20px;" v-model="form.position" autocomplete="off"></el-input>	
			</el-form-item>
			<el-form-item label="公司logo" >
				<!-- element-loading-background="rgba(250, 250, 250, 0.3)"
					:show-file-list="false"  -->
				<el-upload class="avatar-uploader" :action="picUrl" :show-file-list="false"
					element-loading-text="拼命加载中……" :on-progress="change" :before-upload="beforeAvatarUpload"
					v-loading.fullscreen.lock="loading" :data="fileInfo" :on-success="handleAvatarSuccess"
					accept="image/jpeg,image/png">
					<!-- :onerror="imgSrc"  -->
					<img v-if="imageUrl" :src="imageUrl" :onerror="imgSrc" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<div class="tishinews">
					小提示：上传图片只能是JPG/PNG格式且上传图片大小不能超过 5MB！
					<br />图片建议比例:3:2
				</div>
			</el-form-item>
			<div class="submit-wrap">
				<el-button type="primary" @click="handleSubmit">提交</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				options: [{
				  value: '0',
				  label: '水处理'
				}, {
				  value: '1',
				  label: '仪器仪表环保监测'
				}, {
				  value: '2',
				  label: '大气处理'
				}, {
				  value: '3',
				  label: '固废处理'
				}, {
				  value: '4',
				  label: '土壤修复'
				}, {
				  value: '5',
				  label: '配件耗材'
				}, {
				  value: '6',
				  label: '环卫清洁'
				}],
				fenqu:[],
				loading: false,
				imgSrc: 'this.src="' + require('../../assets/img/mr.jpg') + '"',
				fileInfo: {
					type: "news",
				},
				user_id: this.$store.state.USER_ID,
				imageUrl: '',
				form: {
					fenqu_id:'',
					position:'',
					company:'',
					department:'',
					post:'',
					name:'',
					phone:'',
					photo:'',
					id :'',
					shop_id :this.$store.state.USER_ID,
					exhibition_id:'',
					industry:0
				},
				dateData: [],
				rules: {
					title: [{
						required: true,
						message: '请输入公司名称'
					}],
					zhanwei: [{
						required: true,
						message: '请输入心仪的展位号'
					}],
					content: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.content === '') {
								callback(new Error('请输入详细内容'));
							} else {
								callback();
							}
						}
					}]
				},
				picUrl: '',
				// 上传视频
				videoFlag: false,
				//是否显示进度条
				videoUploadPercent: "",
				//进度条的进度，
				isShowUploadVideo: false,
				//显示上传按钮
				videoForm: {
					showVideoPath: ''
				}
			}
		},
		created() {
			this.picUrl = this.$store.state.BASE_URL + '/uploadImgOne.html'
			if(this.form.industry != '' || this.form.industry != null){
				this.options.map((item) => {
					if(this.form.industry == item.value){
						this.form.industry = item.label
					}
				})
			}
		},
		methods: {
			change(event, file, fileList) {
				this.loading = true;
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			handleAvatarSuccess(res, file) {
				if (res.src != null ) {
					this.loading = false;
					this.form.photo = res.src
					this.imageUrl = URL.createObjectURL(file.raw);
				} else {
					this.loading = false;
					this.$message.error(res.data);
				}
			},
			handleSubmit() {
				if(this.form.state == ' '){
					this.form.state = 1
				}
				if(this.form.industry != '' || this.form.industry != null){
					this.options.map((item) => {
						if(this.form.industry == item.label){
							this.form.industry = item.value
						}
					})
				}
				
				this.$refs['form'].validate(valid => {
					if (valid) {
						this.$emit('eventForm', this.form)
					} else {
						this.$message.error('请补全必填项')
						return false
					}
				});
			},
		},
		props: {
			newsForm: {
				type: Object,
				default () {
					return {}
				}
			},
			fenqu: {
				type: Object,
				default () {
					return {}
				}
			}
		},
		watch: {
			newsForm(val) {
				this.form = val
				this.form.vote_id = val.vote_id
				this.form.state = val.state
				this.form.photo =  val.logo
				this.imageUrl = val.logo ? this.$store.state.IMG_URL + val.logo  : ''
				
				
				
				
			},
			fenqu(val){
				this.fenqu = val
			}
		}
	}
</script>

<style scoped>
	.el-form {
		padding: 20px;
		max-width: 1020px;
	}

	.news-wrap>>>.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.news-wrap>>>.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.news-wrap>>>.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.news-wrap>>>.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.submit-wrap {
		text-align: center;
	}

	.tishinews {
		color: #666ee8;
	}
</style>
       